function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { combineReducers } from 'redux';
import { omit } from 'lodash';
import { SET_COLLECTIONS, UPDATE_COLLECTION, UPDATE_COLLECTION_EVENTS, DELETE_COLLECTION } from './actionTypes';
/*
state.collections: {
    123123: {
        events: [12,3,4,5],
        name: Cool Collection,
        secret: 234234,
        id: 123123,
    },
    123124: {
        events: [12,3,4,5],
        name: Cool Collection,
        secret: 234234,
        id: 123123,
    }
}
*/

var entities = function entities(state, _ref) {
  if (state === void 0) {
    state = {};
  }

  var type = _ref.type,
      payload = _ref.payload;
  var nextState = state;

  if (type === SET_COLLECTIONS) {
    nextState = _objectSpread({}, nextState, {}, payload.entities);
  }

  if (type === UPDATE_COLLECTION) {
    var _objectSpread2;

    nextState = _objectSpread({}, nextState, (_objectSpread2 = {}, _objectSpread2[payload.id] = _objectSpread({}, nextState[payload.id], {}, payload), _objectSpread2));
  }

  if (type === UPDATE_COLLECTION_EVENTS) {
    var _objectSpread3;

    nextState = _objectSpread({}, nextState, (_objectSpread3 = {}, _objectSpread3[payload.collectionId] = _objectSpread({}, nextState[payload.collectionId], {
      eventCount: payload.shouldAdd ? nextState[payload.collectionId].eventCount += 1 : nextState[payload.collectionId].eventCount -= 1
    }), _objectSpread3));
  }

  if (type === DELETE_COLLECTION) {
    nextState = omit(nextState, payload);
  }

  return nextState;
};

var hasMoreItems = function hasMoreItems(state, _ref2) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref2.type,
      payload = _ref2.payload;
  var nextState = state;

  if (type === SET_COLLECTIONS && payload.hasMoreItems) {
    nextState = payload.hasMoreItems;
  }

  return nextState;
};

var continuation = function continuation(state, _ref3) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref3.type,
      payload = _ref3.payload;
  var nextState = state;

  if (type === SET_COLLECTIONS && payload.continuation) {
    nextState = payload.continuation;
  }

  return nextState;
};

var hasMoreFollowed = function hasMoreFollowed(state, _ref4) {
  if (state === void 0) {
    state = false;
  }

  var type = _ref4.type,
      payload = _ref4.payload;
  var nextState = state;

  if (type === SET_COLLECTIONS && 'hasMoreFollowed' in payload) {
    nextState = payload.hasMoreFollowed;
  }

  return nextState;
};

var continuationFollowed = function continuationFollowed(state, _ref5) {
  if (state === void 0) {
    state = '';
  }

  var type = _ref5.type,
      payload = _ref5.payload;
  var nextState = state;

  if (type === SET_COLLECTIONS && payload.continuationFollowed) {
    nextState = payload.continuationFollowed;
  }

  return nextState;
};

export default combineReducers({
  entities: entities,
  hasMoreItems: hasMoreItems,
  continuation: continuation,
  hasMoreFollowed: hasMoreFollowed,
  continuationFollowed: continuationFollowed
});